import React from "react";

/**
 * Skeleton placeholder for BenefitCard.
 * Mirrors BenefitCard's structure 1:1 (icon+name+tagline, badge row,
 * highlights list, footer) so the grid doesn't reflow/jump when real
 * data replaces the skeleton.
 */
const BenefitCardSkeleton = () => {
  return (
    <div
      className="relative flex flex-col w-full rounded-2xl border border-[#E8E5F0] bg-white p-4"
      aria-hidden="true"
    >
      {/* Selection toggle placeholder */}
      <div className="absolute top-3.5 right-3.5 h-5 w-5 rounded-full bg-[#F0EEF5] animate-pulse" />

      {/* Icon + Service name + Tagline */}
      <div className="flex items-start gap-3 pr-7">
        <div className="h-11 w-11 rounded-xl bg-[#F0EEF5] animate-pulse shrink-0" />
        <div className="min-w-0 pt-0.5 flex-1 space-y-2">
          <div className="h-3.5 w-3/4 rounded-full bg-[#F0EEF5] animate-pulse" />
          <div className="h-2.5 w-1/2 rounded-full bg-[#F0EEF5] animate-pulse" />
        </div>
      </div>

      {/* Wallet / Credits / Co-pay badge placeholders */}
      <div className="mt-3 flex flex-wrap gap-1.5">
        <div className="h-[22px] w-28 rounded-full bg-[#F0EEF5] animate-pulse" />
        <div className="h-[22px] w-20 rounded-full bg-[#F0EEF5] animate-pulse" />
      </div>

      {/* Service highlight placeholders */}
      <ul className="mt-3 space-y-2">
        {[0, 1, 2].map((i) => (
          <li key={i} className="flex items-start gap-1.5">
            <span className="mt-[5px] h-1 w-1 rounded-full bg-[#E8E5F0] shrink-0" />
            <span
              className="h-2.5 rounded-full bg-[#F0EEF5] animate-pulse"
              style={{ width: `${88 - i * 14}%` }}
            />
          </li>
        ))}
      </ul>

      {/* Footer: Give Details button + Benefit Amount placeholders */}
      <div className="mt-4 pt-3 border-t border-[#F0EEF5] flex items-center justify-between">
        <div className="h-6 w-[92px] rounded-sm bg-[#F0EEF5] animate-pulse" />
        <div className="flex flex-col items-end gap-1.5">
          <div className="h-2.5 w-20 rounded-full bg-[#F0EEF5] animate-pulse" />
          <div className="h-3.5 w-14 rounded-full bg-[#F0EEF5] animate-pulse" />
        </div>
      </div>
    </div>
  );
};

export default BenefitCardSkeleton;